module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__customer-group",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "id": "name",
      "name": "name",
      "required": true,
      "label": "Направление",
      "error": _vm.errors.first('name'),
      "data-vv-name": "name",
      "data-vv-as": ' ',
      "placeholder": "Введите направление"
    },
    model: {
      value: (_vm.zone.name),
      callback: function($$v) {
        _vm.$set(_vm.zone, "name", $$v)
      },
      expression: "zone.name"
    }
  }), _vm._v(" "), (_vm.zone.id && _vm.zone.id != 'new') ? _c('toggle-card', {
    attrs: {
      "visibility": true,
      "heading": 'Населённые пункты'
    }
  }, [_c('z-input-zone-cities', {
    ref: "cities",
    attrs: {
      "zone": _vm.zone
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-467f0990","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/Zone.vue
// module id = 1125
// module chunks = 0